import { FormatMessage } from 'components/IntlProvider/hooks/hooks';

export enum ProjectStatus {
  OFFER_DRAFT = 1,
  OFFER_ACCEPTED = 2,
  OFFER_REFUSED = 3,
  OFFER_CANCELLED = 4,
  PRODUCTS_SENT = 5,
  SURVEYS_SENT = 6,
  SURVEYS_RECEIVED = 7,
  INVOICE_SENT = 8,
  ANALYSIS_DONE = 9,
  PAYMENT_DONE = 10,
  FINISHED = 11,
  OFFER_ARCHIVED = 12,
  COLLECTING_DATA = 13,
  SUSPENDED = 14,
}

export const TRANSLATED_STATUSES = {
  [`${ProjectStatus.OFFER_DRAFT}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.offerDraft.action', 'Accept'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.offerDraft.status', 'Draft'),
  },
  [`${ProjectStatus.OFFER_ACCEPTED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.offerAccepted.ACCEPTED', 'Run'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.offerAccepted.ACCEPTED', 'Draft'),
  },
  [`${ProjectStatus.OFFER_REFUSED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.offerRefused.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.offerRefused.status', 'Refused'),
  },
  [`${ProjectStatus.OFFER_CANCELLED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.offerCancelled.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.offerCancelled.status', 'Cancelled'),
  },
  [`${ProjectStatus.PRODUCTS_SENT}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.productsSent.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.productsSent.status', 'Products sent'),
  },
  [`${ProjectStatus.SURVEYS_SENT}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.surveysSent.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.surveysSent.status', 'Surveys sent'),
  },
  [`${ProjectStatus.SURVEYS_RECEIVED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.surveysReceived.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.surveysReceived.status', 'Surveys received'),
  },
  [`${ProjectStatus.INVOICE_SENT}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.invoiceSent.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.invoiceSent.status', 'Invoice'),
  },
  [`${ProjectStatus.ANALYSIS_DONE}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.analysisDone.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.analysisDone.status', 'Completed'),
  },
  [`${ProjectStatus.PAYMENT_DONE}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.paymentDone.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.paymentDone.status', 'Paid'),
  },
  [`${ProjectStatus.FINISHED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.finished.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.finished.status', 'Completed'),
  },
  [`${ProjectStatus.OFFER_ARCHIVED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.offerArchived.action', 'Unarchive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.offerArchived.status', 'Archived'),
  },
  [`${ProjectStatus.COLLECTING_DATA}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.collectingData.action', 'Running'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.collectingData.status', 'Collecting Data'),
  },
  [`${ProjectStatus.SUSPENDED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.suspended.action', ''),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.suspended.status', 'Suspended'),
  },
};
